/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <ModalBaseConfirmacion>
    <section class="contenedorPrincipal">
      <section>
        <div class="contenedorLogo">
          <img class="imgLogo" src="../../assets/images/ania-logo.png" alt="" />
        </div>
        <div class="separador"></div>
      </section>
      
      <div class="titulo">
        <div class="mensajeEliminar">
          {{ mensajeExito }}
        </div>
        <div class="NombreUsuario">
          <strong v-if="nombreUsuario"> 
            {{ nombreUsuario }}<span class="signoInt">?</span>
          </strong>
        </div>
      </div>

      <section class="contenedorBotones">
        <Button class="btn-regresar" @click="cancelar">Cancelar</Button>
        <Button class="btn-confirmar-eliminar" @click="eliminarUsuario">Confirmar</Button>
      </section>
    </section>
    <LoadScreen v-if="showAddProducto" @cerrar="ocultarAddProd"></LoadScreen>
  </ModalBaseConfirmacion>
</template>

<script>
import ModalBaseConfirmacion from "./ModalBaseConfirmacion.vue";
import LoadScreen from "../Forms/LoadScreen.vue";
import Button from "../Forms/Button.vue";

export default {
  components: {
    ModalBaseConfirmacion,
    LoadScreen,
    Button,
  },
  props: {
    mensajeExito: {
      type: String,
      default: "¿Está seguro que desea eliminar a: ",
    },
    nombreUsuario: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: [],
      showAddProducto: false,
    };
  },
  emits: ["cancelar", "confirmar", "cerrarModal"],
  methods: {
    mostrarAddService() {
      this.showAddProducto = true;
    },
    ocultarAddProd() {
      this.showAddProducto = false;
    },
    cancelar() {
      this.$emit("cancelar");
    },
    eliminarUsuario() {
      this.$emit("cerrarModal");
      this.$emit("confirmar");
    },
  },
};
</script>

<style scoped>
.titulo {
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 23px;
}

.mensajeEliminar {
  display: block;
}

.NombreUsuario {
  font-style: italic;
  color: #2a428c;
  text-transform: capitalize;
}

.contenedorLogo {
  justify-content: center;
  display: flex;
  padding: 30px 0px 10px;
}

.imgLogo {
  height: 60px;
}

.separador {
  border-top: 3px solid #2a428c;
  height: 2px;
  max-width: 100%;
  margin-top: 5px;
  margin-bottom: 30px;
}

.contenedorPrincipal {
  margin: 0px 30px;
}

.contenedorBotones {
  display: flex;
  justify-content: space-evenly;
  max-width: 80%;
  margin: auto;
  padding: 30px 0px 30px;
}

.signoInt {
  color: #000000;
  font-style: normal;
  font-weight: 100;
}

@media (max-width: 767px) {
  .titulo {
    flex-direction: row;
    flex-wrap: wrap;  
    gap: 6px;           
    font-size: 19px;    
  }

  .mensajeEliminar, 
  .NombreUsuario {
    display: inline;    
  }

  .contenedorBotones {
    max-width: 100%;   
  }
}
</style>